












































import { Component, Mixins } from 'vue-property-decorator';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import type { MfdsProductListInfo, MfdsProductRecommendedCodeInfoDialogRequest } from '@/model/CommonModel';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import AiCodingApi from '@/api/AiCodingApi';

@Component({
  components: {CommonButton, CommonPromptDialog}
})
export default class MfdsProductRecommendedCodeInfoDialog extends Mixins(DefaultComponentMixin, DialogEventsMixin) {
  private dialogVisible: boolean = false;
  private drugCode: string = '';
  private onMore: any;
  private mfdsInfo: MfdsProductListInfo = {
    mfdsCode: '',
    mfdsTerm: '',
    mfdsTermEng: '',
    mfdsCancelStatus: '',
    mfdsCancelDate: ''
  };

  get isVisible() {
    return this.dialogVisible;
  }

  get isLoading() {
    return this.loading;
  }

  get getData() {
    return (data: string) => data ?? '-';
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showMfdsProductRecommendedCodeInfoDialog', (params: MfdsProductRecommendedCodeInfoDialogRequest) => {
          this.show(params);
        });
    this.$modal.getEventBus().$on('hideMfdsProductRecommendedCodeInfoDialog', () => this.onConfirm());
  }

  public show(params: MfdsProductRecommendedCodeInfoDialogRequest) {
    this.onMore = () => params.onMore(this);
    if (this.drugCode === params.drugCode) {
      return;
    }

    this.dialogVisible = true;
    this.loading = true;

    AiCodingApi.retrieveMfdsProductCode(params.drugCode)
               .then((res) => {
                 if (!res.success) {
                   return Promise.reject(res.errMsg);
                 }
                 this.mfdsInfo = res.data;
               })
               .catch((errMsg) => this.afterRequestFail(errMsg))
               .finally(() => this.loading = false);
  }

  public onConfirm() {
    this.dialogVisible = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showMfdsProductRecommendedCodeInfoDialog');
    this.$modal.getEventBus().$off('hideMfdsProductRecommendedCodeInfoDialog');
  }
}
